/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

function scrollSite(anchor) {
  // close the menu
  document.querySelector(".burger-icon").click();
  if (window.location.pathname != '/') {
	window.location.href = '/' + anchor;
  }
  else {
	setTimeout(function(){ onScrollTimer(anchor); }, 500);
  }
}

function scrollSiteToolbar(anchor) {
	if (window.location.pathname != '/') {
		window.location.href = '/' + anchor;
	  }
	  else {
		setTimeout(function(){ onScrollTimer(anchor); }, 20);
	  }	
}

function onScrollTimer(anchor, preserveHash) {
	var elem = document.querySelector(anchor);  
	var callback = function() {
		var hash = "#" + elem.id;
		window.location.hash = hash;
	};
  scrollTo(elem, preserveHash ? callback : null);
}

function scrollTo(to, callback, duration = 1500) {
	if (isDomElement(to))
		to = to.offsetTop;

	function move(amount) {
		document.documentElement.scrollTop = amount;
		document.body.parentNode.scrollTop = amount;
		document.body.scrollTop = amount;
	}

	function position() {
		return document.documentElement.offsetTop || document.body.parentNode.offsetTop || document.body.offsetTop;
	}

	var start = position(),
		change = to - start,
		currentTime = 0,
		increment = 20;


	var animateScroll = function() {
		// increment the time
		currentTime += increment;

      	// find the value with the quadratic in-out easing function
		var val = Math.easeInOutQuad(currentTime, start, change, duration);
		// move the document.body
		move(val);

      	// do the animation unless its over
		if (currentTime < duration) {
			requestAnimFrame(animateScroll);

        } else {

          if (callback && typeof(callback) === 'function')
			callback();
		}
	};

  animateScroll();
}

Math.easeInOutQuad = function(t, b, c, d) {
	t /= d / 2;
	if (t < 1) {
		return c / 2 * t * t + b
	}
	t--;
	return -c / 2 * (t * (t - 2) - 1) + b;
};

Math.easeInCubic = function(t, b, c, d) {
	var tc = (t /= d) * t * t;
	return b + c * (tc);
};

Math.inOutQuintic = function(t, b, c, d) {
	var ts = (t /= d) * t,
		tc = ts * t;
	return b + c * (6 * tc * ts + -15 * ts * ts + 10 * tc);
};

function isDomElement(obj) {
    return obj instanceof Element;
}

function isMouseEvent(obj) {
    return obj instanceof MouseEvent;
}

var requestAnimFrame = (function() {
	return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function(callback) {
			window.setTimeout(callback, 1000 / 60);
		};
	})();

$('#CartIsGiftCheckbox').change(function(){		
	if($(this).prop("checked")) {		
		$('#CartGiftNoteContainer').show();
		$("#gift-note").attr("required", true);
	} else {
		$('#CartGiftNoteContainer').hide();
		$("#gift-note").attr("required", false).val("");
	}
});

$('#CartSpecialInstructionsCheckbox').change(function(){	
	if($(this).prop("checked")) {
		$('#CartSpecialInstructionsContainer').show();
		$("#CartSpecialInstructions").attr("required", true);
	} else {
		$('#CartSpecialInstructionsContainer').hide();
		$("#CartSpecialInstructions").attr("required", false).val("");
	}
});

function getUrlParameter(name) {
	name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
	var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
	var results = regex.exec(location.search);
	return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

$(window).on('load', function() {	

	// open up links to our beans in a blank window
	$('a[href="https://www.dandelionchocolate.com/our-beans/#anchor"]').attr("target", "_blank");

	// scroll to the newsletter signup for confirmation notice
	var signedUpForEmailLIst = getUrlParameter("customer_posted");
	if (signedUpForEmailLIst == "true") {
		setTimeout(function(){ onScrollTimer("#shopify-section-footer"); }, 20);	
	}

	// show the notice about shipping delayed until the next monday if ordered after 12pm wednesday
	if (typeof moment !== 'undefined') {
		var warehouseTime = moment(new Date().getTime()).tz('US/Pacific');		
		if ((warehouseTime.day() == 3 && warehouseTime.hour() >= 12) || warehouseTime.day() > 3) {		
			$('.cart__summer-shipping--delayed-delivery').show();	
		} else {		
			$('.cart__summer-shipping--delayed-delivery').hide();
		}
	}

	var fst = getUrlParameter('fst');
	if (fst == 1) {
		$('.spacer').css('minHeight', '150px');
		$('.emailsub-bar').show();
		$('.emailsub-bar__close').click(function() {
			$('.emailsub-bar').hide();			
		});
		$('.announcement-bar__message .msg').text(atob("RnJlZSBzaGlwcGluZyBvbiBhbGwgZG9tZXN0aWMgb3JkZXJzLg=="));
	}	


	var email = getUrlParameter("activate_email");
  if (!email) {
    $("#activate_email_confirm").hide();
  } else {
    $("#activate_email").text(email);
	}
	
	// make the header spacer larger if the announcement bar is visible
	setTimeout(function() {
	if ($('.announcement-bar--visible').length) {
		$('.spacer').css('min-height', '160px');			
	}
	}, 20);
});



// fixes the +/- qty modifiers to be prettier
$('.input-number-increment').click(function() {
	var $input = $(this).parents('.input-number-group').find('.input-number');
	var val = parseInt($input.val(), 10);
	$input.val(val + 1);
	$input.trigger('input');
  });
  
  $('.input-number-decrement').click(function() {
	var $input = $(this).parents('.input-number-group').find('.input-number');
	var val = parseInt($input.val(), 10);
	$input.val(val - 1);
	$input.trigger('input');
  });


function is_touch_device() {
	var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
	var mq = function(query) {
		return window.matchMedia(query).matches;
	}

	if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
		return true;
	}

	// include the 'heartz' as a way to have a non matching MQ to help terminate the join
	// https://git.io/vznFH
	var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
	return mq(query);
}

if(is_touch_device()) {
	document.body.classList.add('user-is-touching');	
} else {
	document.body.classList.add('user-no-touch');
}



$('a.card__link').click(function(e) {
	var card= $(e.target).closest('.card');
	var a = $(e.target).closest('a');
	var url = a.data('href');
	if($(document.body).hasClass('user-is-touching') && !card.hasClass('touch-hover')) {					
		card.addClass('touch-hover');
		e.preventDefault();
	} else {
		return true;
	}		
});

$('a.card__link').blur(function(e) {
	var card= $(e.target).closest('.card');
	card.removeClass('touch-hover');
});


$(window).on('load', function(e) {	

	// Iniitialize photo carousel
	if ($('.main-carousel').length) {
		$('.carousel-cell').removeClass('hide');
		var flkty = new Flickity('.main-carousel', 
			{ "cellAlign": "left", 
				"contain": true, 
				"adaptiveHeight": true, 
				"imagesLoaded": true
			});		
		flkty.resize();		
		flkty.on( 'staticClick', function( event, pointer, cellElement, cellIndex ) {
			// dismiss if cell was not clicked
			if ( !cellElement ) {
				return;
			}
			//console.log(cellElement);

			//flkty.viewFullscreen();

			
		});
	}

	// Initialize experience card carousel
	if ($('.experience-types').length) {
		var $carousel = $('.experience-types').flickity({				
			pageDots: false,
			cellAlign: "left"
		});

		setTimeout(function() { $('.experience-types').removeClass('async-hide'); }, 10);
				
		$carousel.on( 'staticClick.flickity', function( event, pointer, cellElement, cellIndex ) {
			// dismiss if cell was not clicked
			if ( !cellElement ) {
				return;
			}
			console.log(cellElement);
			var anchor = $(cellElement).data('anchor')
			if (anchor) {				
				setTimeout(function(){ onScrollTimer(anchor, true); }, 20);
			}
			
		});
	}
	
});